import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Modal, Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import styles from './AlertsModal.module.scss';

export const AlertsModal = ({
	handleClose,
	open,
	confirmationChek,
	title,
	color,
	value,
	header,
}) => (
	<Modal open={open} onClose={handleClose}>
		<div className={styles.container}>
			<div className={clsx(styles.title, value === 'correct' && styles.hide)}>
				<span className={styles.txt}>{header && header}</span>
			</div>
			<Box bgcolor="#dadada3d" marginTop="13px" height="75px" marginLeft="9px">
				<p className={clsx(styles.warningText, 'largeFont')}>
					{title && title}
				</p>
			</Box>
			<div className={styles.bottomRow}>
				<button
					className={clsx(styles.cancelBt, 'regularFont')}
					onClick={handleClose}
				>
					CANCEL
				</button>
				<span>
					<button
						onClick={() => {
							confirmationChek();
							handleClose();
						}}
						className={clsx(styles.submitBt, 'regularFont')}
					>
						YES
					</button>
				</span>
			</div>
		</div>
	</Modal>
);

AlertsModal.propTypes = {
	confirmDelete: PropTypes.func,
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
};
